var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavOffersActive = function SvgNavOffersActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nav_offers_active_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nav_offers_active_svg__st1{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("g", {
    id: "nav_offers_active_svg__Layer_9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#666",
      strokeWidth: 1.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M12.5 19 23 14.5 33.5 19 23 23.5z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_active_svg__st1",
    d: "M12.5 23.5 23 27.9l10.4-4.1M12.5 27.8 23 32.2l10.5-4.1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 36.1,
    cy: 12.7,
    r: 3.7,
    style: {
      fill: "#f91942"
    }
  })));
};
export default SvgNavOffersActive;